import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AccordionButton from './button';

import SafeHTML from '../../../../components/safe-html';

const Accordion = ({
  anchor,
  content,
  index,
  onClick,
  title,
  visibleIndex,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(visibleIndex.includes(index));
  }, [visibleIndex, index]);

  return (
    <div
      className="tab__container"
      id={anchor}
    >
      <AccordionButton
        isVisible={isVisible}
        onClick={() => {
          const newVisibleIndex = visibleIndex;
          if (isVisible) {
            onClick(newVisibleIndex.filter((value) => value !== index));
            return;
          }

          newVisibleIndex.push(index);
          onClick(newVisibleIndex);
        }}
        title={title}
      />
      { isVisible
        ? (
          <SafeHTML
            className="tab__content"
            html={content}
            tag="div"
          />
        ) : null }
    </div>
  );
};

Accordion.propTypes = {
  anchor: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  visibleIndex: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default Accordion;
